import { Group, Kbd, Text } from '@mantine/core';

export const KeyboardHint = ({ kbd, label }: { kbd: string; label: string }) => (
  <Group gap={4}>
    <Kbd>{kbd}</Kbd>
    <Text size="xs">{label}</Text>
  </Group>
);
